/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var LogoTwitterIcon32Regular = forwardRef('LogoTwitterIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M25.757 5.654a1 1 0 1 0-1.514-1.308l-6.994 8.1-5.936-7.85A1.5 1.5 0 0 0 10.117 4H6.005C4.765 4 4.06 5.417 4.808 6.405l8.243 10.901-7.808 9.04a1 1 0 1 0 1.514 1.308l7.527-8.716 6.402 8.467a1.5 1.5 0 0 0 1.197.595h4.112c1.239 0 1.944-1.416 1.196-2.405l-8.709-11.518 7.275-8.423ZM22.13 26 7.01 6h2.858L24.99 26h-2.858Z" })));
});
